// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import ElementView from './base/element-view';

export default class TimeElementView extends ElementView {
  constructor(props) {
    super(props);

    this.state = {
      textValue: props.value.textValue || '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ textValue: nextProps.value.textValue || '' });
  }

  renderEditable() {
    const { styles } = TimeElementView;

    return (
      <input
        type="time"
        value={this.state.textValue}
        disabled={this.props.disabled}
        onChange={this.handleChange}
        className={css(styles.input)}
      />
    );
  }

  handleChange = (event) => {
    const { value } = event.target;

    this.setState({ textValue: value });

    this.props.value.textValue = value;
    this.props.onChange(this.props.value);
  };
}

const styles = cssInJS({
  input: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: '2px 4px',
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
  },
});

TimeElementView.styles = styles;
